export default {
  "content": "<path fill=\"#028EB7\" d=\"M13.87 15.652H1.781a1.778 1.778 0 01-1.777-1.778v-2.728c0-.314.02-.628.062-.94L1.22 1.55A1.778 1.778 0 012.982.007h9.687c.891 0 1.645.66 1.763 1.543l1.154 8.656c.041.312.062.626.062.94v2.728a1.778 1.778 0 01-1.778 1.778zm.29-5.38l-1.138-8.534a.356.356 0 00-.353-.308H2.982a.356.356 0 00-.352.308l-1.138 8.534a.356.356 0 00.353.402H4.37c.153 0 .289.098.337.243l.55 1.647a.356.356 0 00.336.243h4.466a.356.356 0 00.337-.243l.549-1.647a.356.356 0 01.337-.243h2.525a.356.356 0 00.353-.402z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};